export {SimplePaginationComponent} from './simple-pagination.component';
